<template>
  <div class="d-flex justify-content-between">
    <div class="sale-detail-label">
      <h6>Sale Total ({{ getSaleUnits }}) : {{ $utils.formatMoney(saleTotal - discount.total) }}</h6>
      <h6 v-if="getSaleVat">Sale VAT : {{ $utils.formatMoney(getSaleVat) }}</h6>
    </div>

    <div class="sale-detail-label">
    </div>
    <span class="badge bg-primary text-wrap" v-if="customer">{{ customer.Name }} {{ customer.Surname }}</span>

    <div class="sale-detail-value">
      <h6 v-if="$store.getters.getTipAmount">Tip : {{ $utils.formatMoney($store.getters.getTipAmount) }}</h6>

    </div>
  </div>
</template>

<script>
export default {
  name: "SaleDetails",
  computed: {
    getSaleUnits() {
      return this.$store.getters.getSaleUnits
    },
    getSaleVat() {
      return this.$store.getters.getSaleVat;
    },
    customer() {
      let id = this.$store.getters.getCustomer;
      return this.$store.getters.getDebtorByID(id);
    },
    instructionTotal() {
      if (!this.saleLine.instructions || this.saleLine.instructions.length === 0) return 0.00;
      let total = this.saleLine.instructions.map(i => i.Price * i.count).reduce((acc, n) => Number(n) + Number(acc))
      if (isNaN(total)) {
        return 0.00;
      }
      return Number(total.toFixed(2))
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal + this.$store.getters.getTipAmount
    }, discount() {
      return this.$store.getters.getSaleDiscount
    },
  }
}
</script>

<style lang="scss" scoped>
.sale-details {
  display: grid;
  grid-gap: 5px 10px;
  padding: 10px;
  //grid-template-columns: 50% 50%;
  width: 100%;
  grid-template-columns: 35% 65%;

  .sale-detail-label {
    text-align: left;
  }

  .sale-detail-value {
    text-align: right;
    padding-right: 18px;
  }
}

h4, h5, h6 {
  margin: 0;
}

h4 {
  font-weight: 700;
}
h6{
  font-size: 14px;
}
</style>
